var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-event-messaging c-content"},_vm._l((JSON.parse(_vm.messageTypes)),function(type,index){return _c(_vm.messageComponentName(type),{key:index,tag:"component",attrs:{"content":_vm.messageContent(type)}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }